import { css } from "@emotion/react";
import React, { PropsWithChildren } from "react";

export const PERMISSION_LAYOUT_CHECK = "style-role";
export const PERMISSION_FORCED_DISABLED_CLASS = "force-disabled";
export const PERMISSION_EXCLUDED_CHECK = "excluded";
export const CrudPermissionLayout: React.FC<PropsWithChildren<{ isDisabled: boolean }>> = ({
    isDisabled,
    children,
}) => {
    return (
        <div
            css={css`
                .ant-card-actions {
                    display: none;
                }
                ${isDisabled
                    ? `
                          .${PERMISSION_LAYOUT_CHECK} {
                              .${PERMISSION_FORCED_DISABLED_CLASS}:not(.${PERMISSION_EXCLUDED_CHECK} *), 
                              .ant-select-selector:not(.${PERMISSION_EXCLUDED_CHECK} *),
                              div.group:not(.${PERMISSION_EXCLUDED_CHECK}):not(.${PERMISSION_EXCLUDED_CHECK} *),
                              .ant-picker:not(.${PERMISSION_EXCLUDED_CHECK} *),
                              .can-edit:not(.${PERMISSION_EXCLUDED_CHECK} *),
                              span[role="img"]:not(.${PERMISSION_EXCLUDED_CHECK}):not(.${PERMISSION_EXCLUDED_CHECK} *),
                              button:not(.${PERMISSION_EXCLUDED_CHECK}):not(.${PERMISSION_EXCLUDED_CHECK} *) {
                                  background: rgba(0, 0, 0, 0.04) !important;
                                  color: rgba(0, 0, 0, 0.25) !important;
                                  cursor: not-allowed !important;
                                  pointer-events: none !important;
                                  &:hover {
                                      border-color: #d9d9d9 !important;
                                  }
                              }
                          }
                      `
                    : ``}
            `}
        >
            {children}
        </div>
    );
};
